export const ALL_CHOICE = {
  value: "ALL",
  label: "すべて",
};

export const FIRST_PAGE = 1;

export const DEBOUNCE_DELAY = 500;

export const TAX_RATE = 1.1;

export const MAX_FEE_ITEMS = 5;
